// extracted by mini-css-extract-plugin
export default {"container":"ComboboxCoso_container__Cs7Ge","school":"ComboboxCoso_school__tW2ZM","logo":"ComboboxCoso_logo__FBR98","name":"ComboboxCoso_name__AsDpx"};